<template>
  <div>
    <vs-popup
      fullscreen
      title="افزودن محصول به پلن"
      :active.sync="showModal"
      id="assign-product-popup"
    >
      <div class="vx-card mb-4">
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <div class="vx-card__body card-body">
            <div class="vx-row">
              <div class="vx-col w-full">
                <form>
                  <div class="vx-row mb-6">
                    <div class="vx-col lg:w-4/12 w-full">
                      <label class="vs-select--label">{{
                        $t("Products")
                      }}</label>
                      <treeselect
                        name="agent"
                        :multiple="false"
                        :placeholder="$t('SearchProduct')"
                        :async="true"
                        :load-options="loadOptions"
                        v-validate="'required'"
                        class="search-input"
                        ref="product"
                        @select="onActualProductSelected($event)"
                      />
                    </div>
                    <div class="flex vx-col lg:w-1/4 px-0 mx-5">
                      <ul class="alignment-menu vx-col mt-6">
                        <li
                          @click="definitionDiscountType(2)"
                          style="border-left: 1px solid rgb(202, 202, 202)"
                        >
                          <input
                            id="definitionDiscountTypeInput"
                            v-model="DiscountTypeId"
                            type="radio"
                            value="2"
                            @change="definitionDiscountType($event)"
                          />
                          <label class="label">تخفیف مقداری</label>
                        </li>
                        <li
                          @click="definitionDiscountType(1)"
                          style="border-left: 1px solid rgb(202, 202, 202)"
                        >
                          <input
                            id="definitionDiscountTypeInput"
                            v-model="DiscountTypeId"
                            type="radio"
                            value="1"
                            @change="definitionDiscountType($event)"
                          />
                          <label class="label">تخفیف درصدی</label>
                        </li>
                      </ul>
                      <vs-input
                        class="vx-col lg:w-1/6 mr-3"
                        v-model="discountValue"
                        label="تخفیف"
                      />
                    </div>

                    <div class="flex vx-col lg:w-1/4 px-0 mx-5">
                      <ul class="alignment-menu vx-col mt-6">
                        <li
                          @click="definitionCommissionType(2)"
                          style="border-left: 1px solid rgb(202, 202, 202)"
                        >
                          <input
                            id="definitionCommissionTypeInput"
                            v-model="CommissionTypeId"
                            type="radio"
                            value="2"
                            @change="definitionCommissionType($event)"
                          />
                          <label class="label">کمیسیون مقداری</label>
                        </li>
                        <li
                          @click="definitionCommissionType(1)"
                          style="border-left: 1px solid rgb(202, 202, 202)"
                        >
                          <input
                            id="definitionCommissionTypeInput"
                            v-model="CommissionTypeId"
                            type="radio"
                            value="1"
                            @change="definitionCommissionType($event)"
                          />
                          <label class="label">کمیسیون درصدی</label>
                        </li>
                      </ul>
                      <vs-input
                        class="vx-col lg:w-1/6 mr-3"
                        v-model="commissionValue"
                        label="کمیسیون"
                      />
                    </div>

                    <div class="vx-col lg:w-1/12 w-full">
                      <vs-button
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-plus"
                        class="add-btn"
                        @click.prevent="addedProduct()"
                        v-has-permission="permission34"
                      ></vs-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid1"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('ProductName'), sort: 'ItemCode' },
              { title: 'کمیسیون', sort: 'ProductName' },
              { title: $t('Discounts'), sort: 'ItemCode' },
              { title: $t('Action'), sort: 'Action' },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 50%">
                {{ row.beneficiaryRuleProductInfo.saleProductPersianName }}
              </td>
              <td style="width: 15%">
                {{ row.commissionInfo.amount
                }}{{
                  row.commissionInfo.commissionType == 2
                    ? "   " + "ریال" + "   "
                    : "%"
                }}
              </td>
              <td style="width: 15%">
                {{ row.discountInfo.amount
                }}{{
                  row.discountInfo.productDiscountType == 2
                    ? "   " + "ریال" + "   "
                    : "%"
                }}
              </td>
              <td style="width: 15%">
                <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="onUnassignProduct(row)"
                  class="d-inline"
                  v-has-permission="permission33"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
#assign-product-popup {
  overflow-y: scroll !important;
}
.add-btn {
  margin-top: 1.5rem;
}
.alignment-menu {
  display: inline-flex;
  padding: 0 1em;
  border-radius: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid rgb(202, 202, 202);
  background-color: rgb(230, 230, 230);
  height: 3em;
}
.label {
  display: inline-block;
  color: black;
  border-radius: 4px;
  transition: all 0.1s ease;
  width: 10em;
  text-align: center;
  align-content: center;
  padding-top: 10px;
  height: 100%;

  &:hover,
  &:focus {
    background-color: #9fd4b1;
  }

  &:active {
    background-color: #ceeed8;
    transition: border-color 0.1s ease, background-color 0s;
    border: none;
  }
}

#definitionDiscountTypeInput,
#definitionCommissionTypeInput {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;

  &:checked + .label {
    background-color: #007470;
    color: white;
  }
}
#definitionDiscountTypeInput,
#definitionCommissionTypeInput {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;

  &:checked {
    background-color: #007470;
    color: white;
  }
}
</style>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import Treeselect from "@/components/CustomTreeSelect.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "saleManagement_BasicDefinitions_SalesPartnerPlan_ProductList",
  props: {
    currentPlan: Object,
    show: { default: false },
  },

  data() {
    return {
      permission33: "UnAssignBeneficiaryRule",
      permission34: "AssignBeneficiaryRule",
      DiscountTypeId: 1,
      CommissionTypeId: 1,
      gridDataSource: {},
      gridSearchData: {},
      labels: [],
      labelPersian: "",
      labelEnglish: "",
      productInfo: {},
      product: null,
      model: {},
      commissionValue: 0,
      discountValue: 0,
      totalProduct: 0,
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      searchProduct: "productQuery/productQuery",
      unassignProduct: "SalesPartnerPlan/unassignProduct",
      createProductsPlan: "SalesPartnerPlan/createProductsPlan",
    }),
    loadOptions({ searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          this.searchProduct(searchQuery).then((response) => {
            const options = [];
            response.forEach(function (element) {
              options.push({
                id: element.id,
                label: element.persianName + "   ---   " + element.name,
              });
            });
            callback(null, options);
          });
        }
      }, 2000);
    },

    definitionDiscountType(DiscountTypeValue) {
      this.DiscountTypeId = DiscountTypeValue;
    },
    definitionCommissionType(CommissionTypeValue) {
      this.CommissionTypeId = CommissionTypeValue;
    },
    onActualProductSelected(data) {
      this.labels = data.label.split("   ---   ");
      this.labelPersian = this.labels[0];
      this.labelEnglish = this.labels[1];
      this.productInfo.actualProductId = data.id;
      this.product = null;
    },
    onUnassignProduct(row) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          var promoterPlanId = this.currentPlan.id;
          var saleProductId = row.beneficiaryRuleProductInfo.saleProductId;
          this.unassignProduct({ promoterPlanId, saleProductId }).then(() => {
            this.$refs.grid1.renderGrid();
          });
        }
      });
    },
    addedProduct() {
      this.model = {
        promoterPlanId: this.currentPlan.id,
        commissionInfoCommand: {
          amount: this.commissionValue,
          commissionType: this.CommissionTypeId,
        },
        discountInfoCommand: {
          amount: this.discountValue,
          productDiscountType: this.DiscountTypeId,
        },
        beneficiaryRuleProductInfoCommand: {
          saleProductId: this.productInfo.actualProductId,
          saleProductPersianName: this.labelPersian,
          saleProductEnglishName: this.labelEnglish,
        },
      };
      if (this.discountValue == 0 && this.commissionValue == 0) {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "امکان ثبت کالایی با کمیسیون و تخفیف صفر وجود ندارد!",
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        this.createProductsPlan(this.model).then(() => {
          this.$refs.grid1.renderGrid();
          this.$refs.product.clear();
          this.commissionValue = 0;
          this.discountValue = 0;
          this.DiscountTypeId = 1;
          this.CommissionTypeId = 1;
        });
      }
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.gridDataSource = {
          type: "app",
          service:
            "Promotion/api/PromoterPlan/beneficiary-rules?PromoterPlanId=" +
            this.currentPlan.id +
            "&",
        };
        this.totalProduct = this.gridDataSource.total;
        setTimeout(() => {
          this.$refs.grid1.renderGrid();
        }, 0);
      } else {
        this.gridDataSource = { data: [] };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      }
    },
  },
  components: {
    Treeselect,
    DataGrid,
    "v-select": vSelect,
  },
};
</script>
